export const scheduleType = {
     now : "now",
    later : "later"
}

export const  notificationType={
    muhurt:"Muhurt",
    admin : "Admin"
   
}

export  const MetalType ={
  GOLD :'Gold',
  SILVER :'Silver',
  PLATINUM :'Platinum',
  
}
export const MetalAmount={
  Weight:"Weight",
  Amount:"Amount"
}

export const SchemeName={
 DownloadApp:"DownloadApp",
 MetalPurchase:"MetalPurchase",
 SipPurchase:"SipPurchase"

}
export const CalculationType={
    Fixed:"Fixed",
     Percentage:"Percentage"
}
export const CustomerType={
    standard :"standard",
    vip : "vip"
}

export const ExpireTimeUnit={
    Day:"Day",
    Month:"Month"

}

export const SipTypes={
   GOLD:"Gold",
   SILVER:"Silver",
   PLATINUM:"Platinum",
   MONEY:"Money"
}
export const SipStatusSip = [
  { label: "Pending", value: "PENDING", color: "orange" },
  { label: "Created", value: "CREATED", color: "blue" },
  { label: "Running", value: "RUNNING", color: "orange" },
  { label: "Pause", value: "PAUSE", color: "grey" },
  { label: "Cancelled", value: "CANCELLED", color: "red" },
  { label: "Completed", value: "COMPLETED", color: "green" },
];

export const vipCustomerCriteriaType={
        buy : "buy",
        sip : "sip",
        buyandsip:"buyandsip"
}

export const vipCustomerBenefitType = {
    metalback : "metalback"
}

export const OfferKeys = {
        vipcustomerconfig : "vipcustomerconfig",
        diamondpoints : "diamondpoints",
        flashoffer : "flashoffer"
}
   export const NumericFields = [
      "points", 
      "expireTime",
      "initialTransactions",
      "initialTransactionPoints",
      "afterInitalTransactionsPoints",
      "startPoints",
      "installmentPoints",
      "endPoints"
    ];

    export const AmountType={
        Paisa:"paisa",
        Rupee:"rupee"
    }

   

export const initialDiamondPointsConfig = [
  {
    schemeName: "MetalPurchase",
    displayName: "Metal Purchase",
    enabled: true,
    config: [
      { custType: "standard", metalName: "Gold", enabled: true, initialTransactions: 1, initialTransactionPoints: 10, afterInitalTransactionsPoints: 5, points: 2, calculation_type: "fixed", expireTime: 30, expireTimeUnit: "day" },
      { custType: "standard", metalName: "Silver", enabled: false, initialTransactions: 2, initialTransactionPoints: 15, afterInitalTransactionsPoints: 6, points: 3, calculation_type: "percentage", expireTime: 45, expireTimeUnit: "month" },
      { custType: "standard", metalName: "Platinum", enabled: false, initialTransactions: 3, initialTransactionPoints: 20, afterInitalTransactionsPoints: 7, points: 4, calculation_type: "fixed", expireTime: 60, expireTimeUnit: "day" },
      { custType: "vip", metalName: "Gold", enabled: true, initialTransactions: 1, initialTransactionPoints: 12, afterInitalTransactionsPoints: 6, points: 2, calculation_type: "fixed", expireTime: 30, expireTimeUnit: "day" },
      { custType: "vip", metalName: "Silver", enabled: false, initialTransactions: 2, initialTransactionPoints: 18, afterInitalTransactionsPoints: 9, points: 3, calculation_type: "percentage", expireTime: 45, expireTimeUnit: "month" },
      { custType: "vip", metalName: "Platinum", enabled: false, initialTransactions: 3, initialTransactionPoints: 24, afterInitalTransactionsPoints: 12, points: 4, calculation_type: "fixed", expireTime: 60, expireTimeUnit: "day" }
    ]
  },
  {
    schemeName: "DownloadApp",
    displayName: "Download App",
    enabled: true,
    config: [
      { custType: "standard", enabled: true, points: 10, calculation_type: "fixed", expireTime: 30, expireTimeUnit: "day" },
      { custType: "vip", enabled: true, points: 15, calculation_type: "fixed", expireTime: 60, expireTimeUnit: "day" }
    ]
  }
];

export const subscriptionFrequency = {
  daily: "daily",
  weekly: "weekly",
  biweekly: "biweekly",
  monthly: "monthly",
  quarterly: "quarterly",
  half_yearly: "half_yearly",
  yearly: "yearly",
};
export const CouponType={
  Subscription:"Subscription"
}

export const benefitFields = [
  {
    key: "customer_limit",
    label: "No of Customers",
    restricted: false,
    value: 0,
    description: "",
  },
  {
    key: "admin_limit",
    label: "No of Admins",
    restricted: false,
    value: 0,
    description: "",
  },
  {
    key: "store_limit",
    label: "No of Stores",
    restricted: false,
    value: 0,
    description: "",
  },
  {
    key: "customer_sip_limit",
    label: "No of SIPs",
    restricted: false,
    value: 0,
    description: "",
  },
  {
    key: "sip_plan_limit",
    label: "No of SIP Plans",
    restricted: false,
    value: 0,
    description: "",
  },
  {
    key: "transaction_limit",
    label: "No of Transactions",
    restricted: false,
    value: 0,
    description: "",
  },
  {
    key: "product_limit",
    label: "No of Products",
    restricted: false,
    value: 0,
    description: "",
  },
  {
    key: "sell_transaction_limit",
    label: "Sell Transactions",
    restricted: false,
    value: 0,
    description: "",
  },
  {
    key: "buy_transaction_limit",
    label: "Buy Transactions",
    restricted: false,
    value: 0,
    description: "",
  },
  {
    key: "bulk_gift_user_limit",
    label: "Bulk Gift Limit",
    restricted: false,
    value: 0,
    description: "",
  },
];
export const featureOptions = [
  "Buy",
  "Sell",
  "Gift",
  "Redeem",
  "Deposit Plan",
  "Muhurat Calender",
  "VIP Customer",
  "Diamond Points",
  "Auto Debit",
  "Bulk Gift",
  "Birthday Gift",
  "Registration Gift",
];
export const controlAllFeatureOptions = {
  Buy: "buy",
  Sell: "sell",
  Gift: "gift",
  Redeem: "redeem",
  Sip: "sip",
  Deposit_Plan: "deposit_plan",
  Muhurat_Calender: "muhurat_calender",
  VIP_Customer: "vip_customer",
  Diamond_Points: "diamond_points",
  Sip_Auto_Debit: "sip_auto_debit",
  /** App config featureToggle key (preserve casing; matches backend enum) */
  Auto_group_sip: "auto_group_sip",
  Bulk_Gift: "bulk_gift",
  Birthday_Gift: "birthday_gift",
  Registration_Gift: "registration_gift",
  Look_Book: "look_book",
  Sip_Luckey_Draw: "sip_luckey_draw",
  Metal_Rewards: "metal_rewards",
  Referral_Benefit: "referral_benefit",
  Multi_Winner_Lucky_Draw: "multi_winner_lucky_draw",
  Old_Gift: "old_gift",
  Intro_Screen: "intro_screen",
  Show_Intro_Screen: "show_intro_screen",
  Customer_Interaction: "customer_interaction",
  Buy_Auto_Debit : 'buy_auto_debit',
  Allow_admin_mobile_access: "allow_admin_mobile_access",
  Ext_Whatsapp_Api: "ext_whatsapp_api",
  ext_whatsapp_api: "ext_whatsapp_api",
  Live_Rates: "Live_Rates",
  Ticket_Management:"Ticket_Management",
  Booking_Bullion:"Booking_Bullion",
  Monthly_Holdings: "Monthly_Holdings",
  Auto_Debit_Date_Selection : 'auto_debit_date_selection',
};

/** Human-readable labels for Control All Feature checkboxes */
export const featureOptionDisplayLabels = {
  ext_whatsapp_api: "External WhatsApp API",
  Ext_Whatsapp_Api: "External WhatsApp API",
  show_intro_screen: "Show Intro Screen",
  Show_Intro_Screen: "Show Intro Screen",
  auto_debit_date_selection:"Auto_Debit_Date_Selection",
};

/** Always shown in Control All Feature (even if missing from API enum list). */
export const extraControlAllFeatureOptions = [
  "Allow_admin_mobile_access",
  "Multi_Winner_Lucky_Draw",
];

const controlAllFeatureExcludedOptions = [
  "show_intro_screen",
  "Show_Intro_Screen",
];

export const getControlAllFeatureOptionList = (featuresData = {}) => {
  const fromApi = Array.isArray(featuresData)
    ? featuresData
    : Object.values(featuresData || {});
  return [...new Set([...fromApi, ...extraControlAllFeatureOptions])].filter(
    (feature) =>
      feature &&
      !controlAllFeatureExcludedOptions.includes(String(feature)),
  );
};


export const CurrencyList = {
  AED: "AED",
  AFN: "AFN",
  ALL: "ALL",
  AMD: "AMD",
  ANG: "ANG",
  AOA: "AOA",
  ARS: "ARS",
  AUD: "AUD",
  AWG: "AWG",
  AZN: "AZN",
  BAM: "BAM",
  BBD: "BBD",
  BDT: "BDT",
  BGN: "BGN",
  BHD: "BHD",
  BIF: "BIF",
  BMD: "BMD",
  BND: "BND",
  BOB: "BOB",
  BRL: "BRL",
  BSD: "BSD",
  BTN: "BTN",
  BWP: "BWP",
  BYN: "BYN",
  BZD: "BZD",
  CAD: "CAD",
  CDF: "CDF",
  CHF: "CHF",
  CLP: "CLP",
  CNY: "CNY",
  COP: "COP",
  CRC: "CRC",
  CUP: "CUP",
  CVE: "CVE",
  CZK: "CZK",
  DJF: "DJF",
  DKK: "DKK",
  DOP: "DOP",
  DZD: "DZD",
  EGP: "EGP",
  ERN: "ERN",
  ETB: "ETB",
  EUR: "EUR",
  FJD: "FJD",
  FKP: "FKP",
  FOK: "FOK",
  GBP: "GBP",
  GEL: "GEL",
  GGP: "GGP",
  GHS: "GHS",
  GIP: "GIP",
  GMD: "GMD",
  GNF: "GNF",
  GTQ: "GTQ",
  GYD: "GYD",
  HKD: "HKD",
  HNL: "HNL",
  HRK: "HRK",
  HTG: "HTG",
  HUF: "HUF",
  IDR: "IDR",
  ILS: "ILS",
  IMP: "IMP",
  INR: "INR",
  IQD: "IQD",
  IRR: "IRR",
  ISK: "ISK",
  JEP: "JEP",
  JMD: "JMD",
  JOD: "JOD",
  JPY: "JPY",
  KES: "KES",
  KGS: "KGS",
  KHR: "KHR",
  KID: "KID",
  KMF: "KMF",
  KRW: "KRW",
  KWD: "KWD",
  KYD: "KYD",
  KZT: "KZT",
  LAK: "LAK",
  LBP: "LBP",
  LKR: "LKR",
  LRD: "LRD",
  LSL: "LSL",
  LYD: "LYD",
  MAD: "MAD",
  MDL: "MDL",
  MGA: "MGA",
  MKD: "MKD",
  MMK: "MMK",
  MNT: "MNT",
  MOP: "MOP",
  MRU: "MRU",
  MUR: "MUR",
  MVR: "MVR",
  MWK: "MWK",
  MXN: "MXN",
  MYR: "MYR",
  MZN: "MZN",
  NAD: "NAD",
  NGN: "NGN",
  NIO: "NIO",
  NOK: "NOK",
  NPR: "NPR",
  NZD: "NZD",
  OMR: "OMR",
  PAB: "PAB",
  PEN: "PEN",
  PGK: "PGK",
  PHP: "PHP",
  PKR: "PKR",
  PLN: "PLN",
  PYG: "PYG",
  QAR: "QAR",
  RON: "RON",
  RSD: "RSD",
  RUB: "RUB",
  RWF: "RWF",
  SAR: "SAR",
  SBD: "SBD",
  SCR: "SCR",
  SDG: "SDG",
  SEK: "SEK",
  SGD: "SGD",
  SHP: "SHP",
  SLE: "SLE",
  SOS: "SOS",
  SRD: "SRD",
  SSP: "SSP",
  STN: "STN",
  SYP: "SYP",
  SZL: "SZL",
  THB: "THB",
  TJS: "TJS",
  TMT: "TMT",
  TND: "TND",
  TOP: "TOP",
  TRY: "TRY",
  TTD: "TTD",
  TVD: "TVD",
  TZS: "TZS",
  UAH: "UAH",
  UGX: "UGX",
  USD: "USD",
  UYU: "UYU",
  UZS: "UZS",
  VES: "VES",
  VND: "VND",
  VUV: "VUV",
  WST: "WST",
  XAF: "XAF",
  XCD: "XCD",
  XOF: "XOF",
  XPF: "XPF",
  YER: "YER",
  ZAR: "ZAR",
  ZMW: "ZMW",
  ZWL: "ZWL",
};




